import { Component, OnDestroy, OnInit } from '@angular/core';
import { SegovPage } from 'src/app/app.routes';
import { LinkClickable, SegovSigepoHeaderSectionComponent } from 'src/app/controls/segov-sigepo-header-section/segov-sigepo-header-section.component';
import { SegovSigepoPortalBodyComponent } from 'src/app/controls/segov-sigepo-portal-body/segov-sigepo-portal-body.component';
import { ListagemRetornoAutenticidadeComponent } from './sub-views/listagem-retorno-autenticidade/listagem-retorno-autenticidade.component';
import { ObterPaginaJornalPorAutenticidadeState } from 'src/app/stateManagement/reducers/Autenticidade/obter-pagina-jornal-por-autenticidade.reducer';
import { Store } from '@ngrx/store';
import { filter, Subscription } from 'rxjs';
import { obterPaginaJornalPorAutenticidade, obterPaginaJornalPorAutenticidadeFinish } from 'src/app/stateManagement/actions/Autenticidade/obter-pagina-jornal-por-autenticidade.action';
import { selectDadosObterPaginaJornalPorAutenticidade, selectErrosObterPaginaJornalPorAutenticidade } from 'src/app/stateManagement/selectors/Autenticidade/obter-pagina-jornal-por-autenticidade.selector';
import { PaginaJornalOutputDto } from 'src/app/domain/DTOs/output/jornal/pagina-jornal.output.dto';
import { CommonValidators } from 'src/app/utils/validators/common.validator';
import { ObterArquivoCadernoPorIdState } from 'src/app/stateManagement/reducers/Caderno/obter-arquivo-caderno-por-id.reducer';
import { selectDadosObterArquivoCadernoPorId } from 'src/app/stateManagement/selectors/Caderno/obter-arquivo-caderno-por-id.selector';
import { PdfManager } from 'segov-sigepo-ui-component/projects/segov-sigepo-component/src/lib/utils/pdf-manager.service';
import { ObterArquivoCadernoIdInputDto } from 'src/app/domain/DTOs/input/jornal/obter-arquivo-caderno-id.input.dto';
import { obterArquivoCadernoPorId, obterArquivoCadernoPorIdFinish } from 'src/app/stateManagement/actions/Caderno/obter-arquivo-caderno-por-id.action';
import { CodigoInputComponent } from './sub-views/codigo-input/codigo-input.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { minimoDigitosCodigoAutenticidade } from 'src/app/utils/validators/abstract-control-common.validator';
import { ETipoVisualizacaoMateria } from 'src/app/domain/enums/tipo-visualizacao-materia.enum';
import { CommonMessages } from 'src/app/utils/common.messages';

@Component({
  selector: 'app-autenticidade-page',
  standalone: true,
  imports: [
    ListagemRetornoAutenticidadeComponent,
    SegovSigepoPortalBodyComponent,
    SegovSigepoHeaderSectionComponent,
    CodigoInputComponent,
    FormsModule, ReactiveFormsModule
  ],
  templateUrl: './autenticidade-page.component.html',
  styleUrl: './autenticidade-page.component.css'
})
export class AutenticidadePageComponent implements OnInit, OnDestroy {
  public readonly mensagensAutenticidade = CommonMessages.Autenticidade;
  public RouteStack: LinkClickable[] = [
    { title: "Início", route: SegovPage.Inicio },
    { title: "Autenticidade", route: SegovPage.Autenticidade }
  ];

  public paginaJornalOutputDto?: PaginaJornalOutputDto;
  public pesquisaRealizada = false;
  public carregando = false;
  public blob = new Blob();
  public formCodigo: FormGroup;

  public subObterArquivoCadernoPorId: Subscription;
  private subObterPaginaPorAutenticidade: Subscription;
  private subObterPaginaPorAutenticidadeFalha: Subscription;

  constructor(
    private readonly storeObterPaginaPorCodigoAutenticidade: Store<{ obterPaginaJornalPorAutenticidadeState: ObterPaginaJornalPorAutenticidadeState }>,
    private readonly storeObterArquivoPorCadernoId: Store<{ obterArquivoCadernoPorIdState: ObterArquivoCadernoPorIdState }>) {
    this.subObterPaginaPorAutenticidade = new Subscription();
    this.subObterPaginaPorAutenticidadeFalha = new Subscription();
    this.subObterArquivoCadernoPorId = new Subscription();

    this.formCodigo = new FormGroup({
      codigo: new FormControl('', [Validators.required, minimoDigitosCodigoAutenticidade])
    })
  }

  ngOnInit(): void {
    this.subObterPaginaPorAutenticidade = this.storeObterPaginaPorCodigoAutenticidade.select(selectDadosObterPaginaJornalPorAutenticidade)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        this.paginaJornalOutputDto = response?.dados;
        this.pesquisaRealizada = true;
        this.carregando = false;
        this.getArquivoCadernoPdf();
      });

    this.subObterPaginaPorAutenticidadeFalha = this.storeObterPaginaPorCodigoAutenticidade.select(selectErrosObterPaginaJornalPorAutenticidade)
      .pipe(filter(state => state !== null))
      .subscribe(() => {
        this.pesquisaRealizada = true;
        this.carregando = false;
        this.paginaJornalOutputDto = undefined;
      });

    this.subObterArquivoCadernoPorId = this.storeObterArquivoPorCadernoId.select(selectDadosObterArquivoCadernoPorId)
      .subscribe(response => {
        const pagina = this.paginaJornalOutputDto?.pagina;
        if (response?.dados && pagina && this.paginaJornalOutputDto?.tipoVisualizacaoMateria !== ETipoVisualizacaoMateria.HTML) {
          PdfManager.extractPage("data:application/pdf;base64," + response.dados.arquivo, pagina).then(blob => {
            this.blob = blob;
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.subObterPaginaPorAutenticidade.unsubscribe();
    this.subObterPaginaPorAutenticidadeFalha.unsubscribe();
    this.storeObterPaginaPorCodigoAutenticidade.dispatch(obterPaginaJornalPorAutenticidadeFinish());

    this.subObterArquivoCadernoPorId.unsubscribe();
    this.storeObterArquivoPorCadernoId.dispatch(obterArquivoCadernoPorIdFinish());
  }

  public ValidarTexto(value: string) {
    return value.length > 0 && (value.length < 18 || !CommonValidators.isNumericOnly(value))
  }

  public ObterPaginaPorAutenticidadePesquisa(): void {
    if (this.formCodigo.valid)
      this.getObterPaginaPorAutenticidade(this.formCodigo.get('codigo')?.value);
  }

  public reiniciarPagina() {
    this.paginaJornalOutputDto = undefined;
    this.pesquisaRealizada = false;
    this.carregando = false;
    this.formCodigo.setValue({
      "codigo": ""
    });
  }

  private getObterPaginaPorAutenticidade(inputDto: string): void {
    this.carregando = true;
    this.pesquisaRealizada = false;
    this.paginaJornalOutputDto = undefined;
    this.blob = new Blob();
    this.storeObterPaginaPorCodigoAutenticidade.dispatch(obterPaginaJornalPorAutenticidade({ inputDto }))
  }

  private getArquivoCadernoPdf() {
    if (this.paginaJornalOutputDto?.tipoVisualizacaoMateria !== ETipoVisualizacaoMateria.HTML && this.paginaJornalOutputDto?.idJornal) {
      const inputDto = new ObterArquivoCadernoIdInputDto(this.paginaJornalOutputDto.idJornal);
      this.storeObterArquivoPorCadernoId.dispatch(obterArquivoCadernoPorId({ inputDto }));
    }
  }
}
